module.exports = __webpack_public_path__ + "static/media/CXL_knockout.d64e4303.png";